import React, { useState, useContext } from 'react';
import { MessageSquare, ThumbsUp, Lightbulb, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import { UserContext } from '../../context/UserContext';
interface FeedbackWidgetProps {
  onRequestFeedback?: () => void;
}
export function FeedbackWidget({
  onRequestFeedback
}: FeedbackWidgetProps) {
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const {
    userName
  } = useContext(UserContext);
  const [readFeedbacks, setReadFeedbacks] = useState<number[]>([]);
  // All feedbacks in the system
  const allFeedbacks = [{
    id: 1,
    from: 'Jean Martin',
    to: 'Marie Dupont',
    type: 'positive',
    message: "Excellente présentation lors de la réunion d'équipe.",
    date: '2023-11-10',
    isNew: true
  }, {
    id: 2,
    from: 'Thomas Petit',
    to: 'Marie Dupont',
    type: 'constructive',
    message: "Pense à impliquer davantage l'équipe technique.",
    date: '2023-11-05',
    isNew: true
  }, {
    id: 3,
    from: 'Sophie Bernard',
    to: 'Thomas Petit',
    type: 'positive',
    message: 'Excellent travail sur le refactoring du module de paiement.',
    date: '2023-11-08',
    isNew: true
  }];
  // Filter feedbacks for the current user
  const recentFeedbacks = allFeedbacks.filter(feedback => feedback.to === userName);
  const handleMarkAsRead = (feedbackId: number) => {
    setReadFeedbacks([...readFeedbacks, feedbackId]);
    showToast('Feedback marqué comme lu', 'success');
  };
  const handleViewAllFeedbacks = () => {
    navigate('/performance?tab=feedback');
  };
  const unreadFeedbacks = recentFeedbacks.filter(f => !readFeedbacks.includes(f.id));
  const unreadCount = unreadFeedbacks.filter(f => f.isNew).length;
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-1942">
      <div className="flex items-center justify-between mb-4" data-id="element-1943">
        <div className="flex items-center" data-id="element-1944">
          <h3 className="font-semibold text-gray-900" data-id="element-1945">Feedback reçu</h3>
          {unreadCount > 0 && <span className="ml-2 px-2 py-0.5 bg-red-100 text-red-800 text-xs font-medium rounded-full" data-id="element-1946">
              {unreadCount} nouveau
            </span>}
        </div>
        <MessageSquare className="h-5 w-5 text-blue-600" data-id="element-1947" />
      </div>
      {unreadFeedbacks.length > 0 ? <>
          <div className="space-y-3 mb-4 flex-1" data-id="element-1948">
            {unreadFeedbacks.map(feedback => <div key={feedback.id} className={`border-l-4 ${feedback.type === 'positive' ? 'border-green-500 bg-green-50' : 'border-amber-500 bg-amber-50'} p-3 rounded-r-lg`} data-id="element-1949">
                <div className="flex items-start justify-between mb-2" data-id="element-1950">
                  <div className="flex items-center" data-id="element-1951">
                    {feedback.type === 'positive' ? <ThumbsUp className="h-4 w-4 text-green-600 mr-2" data-id="element-1952" /> : <Lightbulb className="h-4 w-4 text-amber-600 mr-2" data-id="element-1953" />}
                    <span className="text-sm font-medium text-gray-900" data-id="element-1954">
                      {feedback.from}
                    </span>
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-1955">{feedback.date}</span>
                </div>
                <p className="text-sm text-gray-700 line-clamp-2 mb-2" data-id="element-1956">
                  {feedback.message}
                </p>
                <button onClick={() => handleMarkAsRead(feedback.id)} className="text-xs text-green-600 hover:text-green-800 font-medium flex items-center mt-2" data-id="element-1957">
                  <Check className="h-3 w-3 mr-1" data-id="element-1958" />
                  Marquer comme lu
                </button>
              </div>)}
          </div>
          <div className="space-y-2 mt-auto" data-id="element-1959">
            <button onClick={handleViewAllFeedbacks} className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1960">
              Voir tous les feedbacks
            </button>
            <button onClick={onRequestFeedback} className="w-full py-2 px-4 border-2 border-blue-600 text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1961">
              Demander du feedback
            </button>
          </div>
        </> : <>
          <div className="text-center py-8 flex-1 flex flex-col items-center justify-center" data-id="element-1962">
            <MessageSquare className="h-12 w-12 text-gray-300 mx-auto mb-3" data-id="element-1963" />
            <p className="text-gray-500 text-sm mb-4" data-id="element-1964">Aucun nouveau feedback</p>
          </div>
          <div className="space-y-2 mt-auto" data-id="element-1965">
            <button onClick={handleViewAllFeedbacks} className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1966">
              Voir tous les feedbacks
            </button>
            <button onClick={onRequestFeedback} className="w-full py-2 px-4 border-2 border-blue-600 text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1967">
              Demander du feedback
            </button>
          </div>
        </>}
    </div>;
}